import React from 'react';

import PropTypes from 'prop-types';

import Content from '@/components/SchedulePage/Timeline/Content';
import InspectorList from '@/components/SchedulePage/Timeline/InspectorList';
import classes from '@/components/SchedulePage/Timeline/style.module.scss';

const TimelineComponent = ({ ordersLoading, inspectorsLoading }) => (
  <div className={classes.timeline}>
    <div className={classes.timelineInner}>
      <InspectorList busy={inspectorsLoading} />

      <div className={classes.contentWrapper}>
        <Content busy={ordersLoading} />
      </div>
    </div>
  </div>
);

TimelineComponent.propTypes = {
  ordersLoading: PropTypes.bool.isRequired,
  inspectorsLoading: PropTypes.bool.isRequired,
};

export default TimelineComponent;
